"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAbsenceRequestParams = exports.UpdateAbsenceRequestParams = exports.RequestAbsenceParams = exports.GetAbsencesParams = exports.UpdateRosterTargetsParams = exports.GetRosterTargetsParams = exports.TimeTrackerLog = exports.TimeTrackerLogEvent = exports.StartSetupPaymentResponse = exports.StartSetupPaymentParams = exports.ImportVenueParams = exports.CommitCashbookParams = exports.UnlockRevenueEntriesParams = exports.UpdateRevenuePredictionsParams = exports.GetRevenuePredictionsParams = exports.UpdateRevenueGroupParams = exports.GetRevenueGroupsParams = exports.UpdateRevenueEntriesParams = exports.GetRevenueEntriesParams = exports.GetRevenueEntriesCountParams = exports.IgnoreIssuesParams = exports.GetEmployeeIssuesParams = exports.GetRevenueIssuesParams = exports.GetIssuesParams = exports.SendMessageParams = exports.GetPublishedRosterParams = exports.PublishRosterParams = exports.SetPasswordParams = exports.RequestSetPasswordParams = exports.RestoreDeletedTimeEntriesParams = exports.UpdateTimeEntriesParams = exports.UpdateTimeEntriesContext = exports.GetTimeEntriesParams = exports.DeleteEmployeeParams = exports.UpdateEmployeesParams = exports.UpdateEmployeeParams = exports.GetEmployeesParams = exports.CreateEmployeeParams = exports.UpdateDepartmentParams = exports.CreateDepartmentParams = exports.CreateCompanyParams = exports.UpdateVenueParams = exports.CreateVenueParams = exports.UpdateCompanyParams = exports.GetCompanyParams = exports.UpdateBillingParams = exports.RevokeSessionParams = exports.LoginParams = exports.UpdateAccountParams = exports.MaxFileSize = void 0;
exports.API = exports.GetSchoolHolidaysParams = exports.GetWeatherPredictionsParams = exports.TermsAndConditionsState = exports.GetSavingsReportsParams = exports.SavingsReport = exports.CostReport = exports.GetCostReportsParams = exports.DeletePaymentMethodParams = exports.SendInvoiceParams = exports.DeleteDraftInvoiceParams = exports.TimeReport = exports.GetTimeReportsParams = exports.ResetBalancesParams = exports.GetCommonWorkDaysParams = exports.GetDailyResultsParams = exports.GetBalancesParams = exports.GetTimeLogEventsParams = exports.CreateOrUpdateTimeLogDeviceParams = exports.ExportResponse = exports.ExportParams = exports.ExportFormat = exports.CompanyExport = exports.GetInvoicesParams = exports.ImportCompanyResponse = exports.ImportCoreDataResponse = exports.ImportCoreDataParams = exports.ExportCompanyParams = exports.SocialSecurityRegistrationResponse = exports.SocialSecurityRegistrationParams = exports.CreateJobApplicationParams = exports.CreateOrUpdateJobPostingParams = exports.GetDocumentsParams = exports.CreateOrUpdateDocumentParams = exports.GetAvailabilitesParams = exports.GetPublicRosterParams = exports.GetPublicRosterUrlResponse = exports.GetPublicRosterUrlParams = exports.GetRosterNotesParams = exports.JoinCompanyParams = exports.GetInviteResponse = exports.CreateInvitesParams = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const model_1 = require("./model");
const invoice_1 = require("./invoice");
const utils_1 = require("./utils");
const index_1 = require("./api/rpc/index");
const safe_assign_1 = require("./api/rpc/safe-assign");
const employee_tag_dto_1 = require("./api/rpc/employee-tag.dto");
class DTO {
    constructor(props) {
        if (props) {
            Object.assign(this, props);
        }
    }
}
/**
 * Decorator for defining request handler methods
 */
function Handler(input, output, { transforms } = {}) {
    return (proto, method) => {
        if (!proto.handlerDefinitions) {
            proto.handlerDefinitions = [];
        }
        proto.handlerDefinitions.push({
            method,
            input,
            output,
            transforms,
        });
    };
}
exports.MaxFileSize = 1024 * 1024 * 10;
class UpdateAccountParams extends DTO {
}
exports.UpdateAccountParams = UpdateAccountParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "password", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateAccountParams.prototype, "lastName", void 0);
class LoginParams extends DTO {
}
exports.LoginParams = LoginParams;
class RevokeSessionParams extends DTO {
}
exports.RevokeSessionParams = RevokeSessionParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], RevokeSessionParams.prototype, "id", void 0);
class UpdateBillingParams extends DTO {
}
exports.UpdateBillingParams = UpdateBillingParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "addressLine1", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "addressLine2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateBillingParams.prototype, "comments", void 0);
class GetCompanyParams extends DTO {
}
exports.GetCompanyParams = GetCompanyParams;
class UpdateCompanyParams extends DTO {
}
exports.UpdateCompanyParams = UpdateCompanyParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "features", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "partnerIntegrations", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => UpdateBillingParams),
    __metadata("design:type", UpdateBillingParams)
], UpdateCompanyParams.prototype, "billing", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateCompanyParams.prototype, "comments", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.CompanyLifeCycleEvent),
    __metadata("design:type", model_1.CompanyLifeCycleEvent)
], UpdateCompanyParams.prototype, "newLifeCycleEvent", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.DocumentTag),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "documentTags", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => index_1.EmployeeTagDTO),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "employeeTags", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.BonusType),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "bonusTypes", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.BenefitType),
    __metadata("design:type", Array)
], UpdateCompanyParams.prototype, "benefitTypes", void 0);
class CreateVenueParams extends DTO {
}
exports.CreateVenueParams = CreateVenueParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateVenueParams.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Object)
], CreateVenueParams.prototype, "venueNumber", void 0);
class UpdateVenueParams extends DTO {
}
exports.UpdateVenueParams = UpdateVenueParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], UpdateVenueParams.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateVenueParams.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Object)
], UpdateVenueParams.prototype, "venueNumber", void 0);
class CreateCompanyParams extends DTO {
}
exports.CreateCompanyParams = CreateCompanyParams;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "country", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "phone", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => CreateVenueParams),
    __metadata("design:type", CreateVenueParams)
], CreateCompanyParams.prototype, "venue", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", String)
], CreateCompanyParams.prototype, "billingMode", void 0);
class CreateDepartmentParams extends DTO {
}
exports.CreateDepartmentParams = CreateDepartmentParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], CreateDepartmentParams.prototype, "venue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateDepartmentParams.prototype, "name", void 0);
class UpdateDepartmentParams extends DTO {
}
exports.UpdateDepartmentParams = UpdateDepartmentParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], UpdateDepartmentParams.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateDepartmentParams.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateDepartmentParams.prototype, "order", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateDepartmentParams.prototype, "rosterOrder", void 0);
class CreateEmployeeParams {
    constructor(vals) {
        this.firstName = "";
        this.lastName = "";
        this.title = "";
        this.callName = "";
        this.birthName = "";
        this.birthCity = "";
        this.birthCountry = "";
        this.nationality = "";
        this.taxId = "";
        this.socialSecurityNumber = "";
        this.notes = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.phone2 = "";
        this.avatar = "";
        this.timePin = "";
        this.staffNumber = null;
        this.autoMeal = 0;
        this.positions = [];
        Object.assign(this, vals);
    }
}
exports.CreateEmployeeParams = CreateEmployeeParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "callName", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], CreateEmployeeParams.prototype, "birthday", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthCity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(model_1.Gender),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "gender", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "taxId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "socialSecurityNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "phone2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "avatar", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateEmployeeParams.prototype, "timePin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "autoMeal", void 0);
__decorate([
    (0, class_validator_1.IsInt)({ each: true }),
    __metadata("design:type", Array)
], CreateEmployeeParams.prototype, "positions", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => model_1.Contract),
    __metadata("design:type", model_1.Contract)
], CreateEmployeeParams.prototype, "contract", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], CreateEmployeeParams.prototype, "access", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "initialHours", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CreateEmployeeParams.prototype, "initialVacationDays", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => index_1.EmployeeTagDTO),
    __metadata("design:type", Array)
], CreateEmployeeParams.prototype, "tags", void 0);
class GetEmployeesParams {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.GetEmployeesParams = GetEmployeesParams;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GetEmployeesParams.prototype, "filters", void 0);
class UpdateEmployeeParams extends DTO {
}
exports.UpdateEmployeeParams = UpdateEmployeeParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "callName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthCity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "birthCountry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "nationality", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(model_1.Gender),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "gender", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "taxId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "socialSecurityNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "birthday", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "postalCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "phone2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "avatar", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UpdateEmployeeParams.prototype, "timePin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "staffNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "autoMeal", void 0);
__decorate([
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "positions", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => model_1.Contract),
    __metadata("design:type", model_1.Contract)
], UpdateEmployeeParams.prototype, "contract", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], UpdateEmployeeParams.prototype, "deleteContract", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], UpdateEmployeeParams.prototype, "access", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(model_1.Role),
    __metadata("design:type", Number)
], UpdateEmployeeParams.prototype, "role", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], UpdateEmployeeParams.prototype, "deleteDanglingEntries", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "shiftTemplates", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => index_1.EmployeeTagDTO),
    __metadata("design:type", Array)
], UpdateEmployeeParams.prototype, "tags", void 0);
class UpdateEmployeesParams extends DTO {
}
exports.UpdateEmployeesParams = UpdateEmployeesParams;
class DeleteEmployeeParams extends DTO {
}
exports.DeleteEmployeeParams = DeleteEmployeeParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DeleteEmployeeParams.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DeleteEmployeeParams.prototype, "deleteDanglingEntries", void 0);
class GetTimeEntriesParams extends DTO {
}
exports.GetTimeEntriesParams = GetTimeEntriesParams;
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], GetTimeEntriesParams.prototype, "employee", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], GetTimeEntriesParams.prototype, "department", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], GetTimeEntriesParams.prototype, "venue", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(model_1.TimeEntryType, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], GetTimeEntriesParams.prototype, "type", void 0);
var UpdateTimeEntriesContext;
(function (UpdateTimeEntriesContext) {
    UpdateTimeEntriesContext["OfferSwap"] = "offer_swap";
    UpdateTimeEntriesContext["TakeUnassigned"] = "take_unassigned";
    UpdateTimeEntriesContext["TakeOffered"] = "take_offered";
})(UpdateTimeEntriesContext || (exports.UpdateTimeEntriesContext = UpdateTimeEntriesContext = {}));
class UpdateTimeEntriesParams extends DTO {
}
exports.UpdateTimeEntriesParams = UpdateTimeEntriesParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Array)
], UpdateTimeEntriesParams.prototype, "updated", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Array)
], UpdateTimeEntriesParams.prototype, "removed", void 0);
class RestoreDeletedTimeEntriesParams extends DTO {
}
exports.RestoreDeletedTimeEntriesParams = RestoreDeletedTimeEntriesParams;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], RestoreDeletedTimeEntriesParams.prototype, "employeeId", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], RestoreDeletedTimeEntriesParams.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], RestoreDeletedTimeEntriesParams.prototype, "to", void 0);
class RequestSetPasswordParams extends DTO {
}
exports.RequestSetPasswordParams = RequestSetPasswordParams;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], RequestSetPasswordParams.prototype, "email", void 0);
class SetPasswordParams extends DTO {
}
exports.SetPasswordParams = SetPasswordParams;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Number)
], SetPasswordParams.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "password", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "token", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SetPasswordParams.prototype, "oldPassword", void 0);
class PublishRosterParams extends DTO {
}
exports.PublishRosterParams = PublishRosterParams;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PublishRosterParams.prototype, "venue", void 0);
class GetPublishedRosterParams extends DTO {
}
exports.GetPublishedRosterParams = GetPublishedRosterParams;
class SendMessageParams extends DTO {
}
exports.SendMessageParams = SendMessageParams;
class GetIssuesParams extends DTO {
}
exports.GetIssuesParams = GetIssuesParams;
class GetRevenueIssuesParams {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.GetRevenueIssuesParams = GetRevenueIssuesParams;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GetRevenueIssuesParams.prototype, "from", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GetRevenueIssuesParams.prototype, "to", void 0);
class GetEmployeeIssuesParams {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.GetEmployeeIssuesParams = GetEmployeeIssuesParams;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GetEmployeeIssuesParams.prototype, "from", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GetEmployeeIssuesParams.prototype, "to", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], GetEmployeeIssuesParams.prototype, "includeIgnored", void 0);
class IgnoreIssuesParams extends DTO {
}
exports.IgnoreIssuesParams = IgnoreIssuesParams;
class GetRevenueEntriesCountParams extends DTO {
}
exports.GetRevenueEntriesCountParams = GetRevenueEntriesCountParams;
class GetRevenueEntriesParams extends DTO {
}
exports.GetRevenueEntriesParams = GetRevenueEntriesParams;
__decorate([
    (0, class_validator_1.IsEnum)(model_1.RevenueType, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], GetRevenueEntriesParams.prototype, "type", void 0);
class UpdateRevenueEntriesParams extends DTO {
}
exports.UpdateRevenueEntriesParams = UpdateRevenueEntriesParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueEntry),
    __metadata("design:type", Array)
], UpdateRevenueEntriesParams.prototype, "updated", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueEntry),
    __metadata("design:type", Array)
], UpdateRevenueEntriesParams.prototype, "removed", void 0);
class GetRevenueGroupsParams extends DTO {
}
exports.GetRevenueGroupsParams = GetRevenueGroupsParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], GetRevenueGroupsParams.prototype, "venue", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(model_1.RevenueType, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], GetRevenueGroupsParams.prototype, "type", void 0);
class UpdateRevenueGroupParams extends DTO {
}
exports.UpdateRevenueGroupParams = UpdateRevenueGroupParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueGroup),
    __metadata("design:type", model_1.RevenueGroup)
], UpdateRevenueGroupParams.prototype, "group", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueGroup),
    __metadata("design:type", model_1.RevenueGroup)
], UpdateRevenueGroupParams.prototype, "merge", void 0);
class GetRevenuePredictionsParams extends DTO {
}
exports.GetRevenuePredictionsParams = GetRevenuePredictionsParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], GetRevenuePredictionsParams.prototype, "venue", void 0);
class UpdateRevenuePredictionsParams extends DTO {
}
exports.UpdateRevenuePredictionsParams = UpdateRevenuePredictionsParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenuePrediction),
    __metadata("design:type", Array)
], UpdateRevenuePredictionsParams.prototype, "updated", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenuePrediction),
    __metadata("design:type", Array)
], UpdateRevenuePredictionsParams.prototype, "removed", void 0);
class UnlockRevenueEntriesParams extends DTO {
}
exports.UnlockRevenueEntriesParams = UnlockRevenueEntriesParams;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UnlockRevenueEntriesParams.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], UnlockRevenueEntriesParams.prototype, "from", void 0);
class CommitCashbookParams extends DTO {
}
exports.CommitCashbookParams = CommitCashbookParams;
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], CommitCashbookParams.prototype, "venue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CommitCashbookParams.prototype, "until", void 0);
class ImportVenueParams extends DTO {
}
exports.ImportVenueParams = ImportVenueParams;
class StartSetupPaymentParams extends DTO {
}
exports.StartSetupPaymentParams = StartSetupPaymentParams;
class StartSetupPaymentResponse extends DTO {
}
exports.StartSetupPaymentResponse = StartSetupPaymentResponse;
class TimeTrackerLogEvent {
    constructor(vals = {}) {
        this.offline = false;
        Object.assign(this, vals);
    }
}
exports.TimeTrackerLogEvent = TimeTrackerLogEvent;
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeTrackerLogEvent.prototype, "time", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], TimeTrackerLogEvent.prototype, "lastSync", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeSettings),
    __metadata("design:type", model_1.TimeSettings)
], TimeTrackerLogEvent.prototype, "timeSettings", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Array)
], TimeTrackerLogEvent.prototype, "entries", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Array)
], TimeTrackerLogEvent.prototype, "available", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", model_1.TimeEntry)
], TimeTrackerLogEvent.prototype, "entry", void 0);
class TimeTrackerLog {
    constructor() {
        this.events = [];
    }
    add(...evt) {
        const newEvents = evt.map((e) => new TimeTrackerLogEvent(e));
        this.events = [...this.events, ...newEvents].sort((a, b) => b.time.getTime() - a.time.getTime()).slice(0, 500);
    }
}
exports.TimeTrackerLog = TimeTrackerLog;
__decorate([
    (0, class_transformer_1.Type)(() => TimeTrackerLogEvent),
    __metadata("design:type", Array)
], TimeTrackerLog.prototype, "events", void 0);
class GetRosterTargetsParams extends DTO {
}
exports.GetRosterTargetsParams = GetRosterTargetsParams;
class UpdateRosterTargetsParams extends DTO {
}
exports.UpdateRosterTargetsParams = UpdateRosterTargetsParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RosterTargets),
    __metadata("design:type", Array)
], UpdateRosterTargetsParams.prototype, "updated", void 0);
class GetAbsencesParams extends DTO {
}
exports.GetAbsencesParams = GetAbsencesParams;
class RequestAbsenceParams extends DTO {
}
exports.RequestAbsenceParams = RequestAbsenceParams;
class UpdateAbsenceRequestParams extends DTO {
}
exports.UpdateAbsenceRequestParams = UpdateAbsenceRequestParams;
class DeleteAbsenceRequestParams extends DTO {
}
exports.DeleteAbsenceRequestParams = DeleteAbsenceRequestParams;
class CreateInvitesParams extends DTO {
}
exports.CreateInvitesParams = CreateInvitesParams;
class GetInviteResponse extends DTO {
}
exports.GetInviteResponse = GetInviteResponse;
class JoinCompanyParams extends DTO {
}
exports.JoinCompanyParams = JoinCompanyParams;
class GetRosterNotesParams extends DTO {
}
exports.GetRosterNotesParams = GetRosterNotesParams;
class GetPublicRosterUrlParams extends DTO {
}
exports.GetPublicRosterUrlParams = GetPublicRosterUrlParams;
class GetPublicRosterUrlResponse extends DTO {
}
exports.GetPublicRosterUrlResponse = GetPublicRosterUrlResponse;
class GetPublicRosterParams extends DTO {
}
exports.GetPublicRosterParams = GetPublicRosterParams;
class GetAvailabilitesParams extends DTO {
}
exports.GetAvailabilitesParams = GetAvailabilitesParams;
class CreateOrUpdateDocumentParams extends DTO {
}
exports.CreateOrUpdateDocumentParams = CreateOrUpdateDocumentParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.DocumentTag),
    __metadata("design:type", Array)
], CreateOrUpdateDocumentParams.prototype, "tags", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.Form),
    __metadata("design:type", Object)
], CreateOrUpdateDocumentParams.prototype, "form", void 0);
class GetDocumentsParams extends DTO {
}
exports.GetDocumentsParams = GetDocumentsParams;
class CreateOrUpdateJobPostingParams extends DTO {
}
exports.CreateOrUpdateJobPostingParams = CreateOrUpdateJobPostingParams;
class CreateJobApplicationParams extends DTO {
}
exports.CreateJobApplicationParams = CreateJobApplicationParams;
class SocialSecurityRegistrationParams extends DTO {
}
exports.SocialSecurityRegistrationParams = SocialSecurityRegistrationParams;
class SocialSecurityRegistrationResponse extends DTO {
}
exports.SocialSecurityRegistrationResponse = SocialSecurityRegistrationResponse;
class ExportCompanyParams extends DTO {
}
exports.ExportCompanyParams = ExportCompanyParams;
class ImportCoreDataParams extends DTO {
}
exports.ImportCoreDataParams = ImportCoreDataParams;
class ImportCoreDataResponse extends DTO {
}
exports.ImportCoreDataResponse = ImportCoreDataResponse;
class ImportCompanyResponse extends DTO {
}
exports.ImportCompanyResponse = ImportCompanyResponse;
class GetInvoicesParams extends DTO {
}
exports.GetInvoicesParams = GetInvoicesParams;
class CompanyExport extends DTO {
}
exports.CompanyExport = CompanyExport;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.Company),
    __metadata("design:type", model_1.Company)
], CompanyExport.prototype, "company", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Array)
], CompanyExport.prototype, "timeEntries", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RosterTargets),
    __metadata("design:type", Array)
], CompanyExport.prototype, "rosterTargets", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RosterNote),
    __metadata("design:type", Array)
], CompanyExport.prototype, "rosterNotes", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.Absence),
    __metadata("design:type", Array)
], CompanyExport.prototype, "absences", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.Availability),
    __metadata("design:type", Array)
], CompanyExport.prototype, "availabilities", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.Document),
    __metadata("design:type", Array)
], CompanyExport.prototype, "documents", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.JobPosting),
    __metadata("design:type", Array)
], CompanyExport.prototype, "jobPostings", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueGroup),
    __metadata("design:type", Array)
], CompanyExport.prototype, "revenueGroups", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.RevenueEntry),
    __metadata("design:type", Array)
], CompanyExport.prototype, "revenueEntries", void 0);
var ExportFormat;
(function (ExportFormat) {
    ExportFormat["PayrollReportDetailed"] = "payroll_report_detailed";
    ExportFormat["PayrollReportOverview"] = "payroll_report_overview";
    ExportFormat["PayrollDatevLodas"] = "payroll_datev_lodas";
    ExportFormat["PayrollDatevLG"] = "payroll_datev_lg";
    ExportFormat["PayrollAgenda"] = "payroll_agenda";
    ExportFormat["PayrollAgendaEmployeeCoreData"] = "payroll_agenda_employee_core_data";
    ExportFormat["PayrollAgendaCalendar"] = "payroll_agenda_calendar";
    ExportFormat["PayrollLexware"] = "payroll_lexware";
    ExportFormat["PayrollAddison"] = "payroll_addison";
    ExportFormat["PayrollLohnAG"] = "payroll_lohn_ag";
    ExportFormat["PayrollSage"] = "payroll_sage";
    ExportFormat["PayrollBMDWages"] = "payroll_bmd";
    ExportFormat["PayrollBMDAbsences"] = "payroll_bmd_absences";
    ExportFormat["TimeSheet"] = "time_sheet";
    ExportFormat["RosterExcel"] = "roster_excel";
    ExportFormat["OvertimeExcel"] = "balances_overtime_excel";
    ExportFormat["AverageWorkTimeExcel"] = "balances_average_work_time_excel";
    ExportFormat["BalancesTimeExcel"] = "balances_time_excel";
    ExportFormat["BalancesVacationExcel"] = "balances_vacation_excel";
    ExportFormat["BalancesBonusesExcel"] = "balances_bonuses_excel";
    ExportFormat["CashbookDatev"] = "cashbook_datev";
    ExportFormat["CashbookDatevOnline"] = "cashbook_datev_online";
    ExportFormat["CashbookLexware"] = "cashbook_lexware";
    ExportFormat["CashbookGeneric"] = "cashbook_generic";
    ExportFormat["CashbookPDF"] = "cashbook_pdf";
    ExportFormat["EmployeeDataPDF"] = "employee_data_pdf";
    ExportFormat["EmployeeDataCSV"] = "employee_data_csv";
    ExportFormat["EmployeeTableExcel"] = "employee_table_excel";
})(ExportFormat || (exports.ExportFormat = ExportFormat = {}));
class ExportParams extends DTO {
}
exports.ExportParams = ExportParams;
__decorate([
    (0, class_transformer_1.Type)(() => model_1.DocumentTag),
    __metadata("design:type", Array)
], ExportParams.prototype, "tags", void 0);
class ExportResponse extends DTO {
}
exports.ExportResponse = ExportResponse;
class CreateOrUpdateTimeLogDeviceParams extends DTO {
}
exports.CreateOrUpdateTimeLogDeviceParams = CreateOrUpdateTimeLogDeviceParams;
class GetTimeLogEventsParams extends DTO {
}
exports.GetTimeLogEventsParams = GetTimeLogEventsParams;
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], GetTimeLogEventsParams.prototype, "fromTime", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], GetTimeLogEventsParams.prototype, "toTime", void 0);
class GetBalancesParams extends DTO {
}
exports.GetBalancesParams = GetBalancesParams;
class GetDailyResultsParams extends DTO {
}
exports.GetDailyResultsParams = GetDailyResultsParams;
class GetCommonWorkDaysParams extends DTO {
}
exports.GetCommonWorkDaysParams = GetCommonWorkDaysParams;
class ResetBalancesParams extends DTO {
}
exports.ResetBalancesParams = ResetBalancesParams;
class GetTimeReportsParams extends DTO {
}
exports.GetTimeReportsParams = GetTimeReportsParams;
class TimeReport extends DTO {
}
exports.TimeReport = TimeReport;
class DeleteDraftInvoiceParams extends DTO {
}
exports.DeleteDraftInvoiceParams = DeleteDraftInvoiceParams;
class SendInvoiceParams extends DTO {
}
exports.SendInvoiceParams = SendInvoiceParams;
class DeletePaymentMethodParams extends DTO {
}
exports.DeletePaymentMethodParams = DeletePaymentMethodParams;
class GetCostReportsParams extends DTO {
}
exports.GetCostReportsParams = GetCostReportsParams;
class CostReport extends DTO {
}
exports.CostReport = CostReport;
class SavingsReport extends DTO {
}
exports.SavingsReport = SavingsReport;
class GetSavingsReportsParams extends DTO {
}
exports.GetSavingsReportsParams = GetSavingsReportsParams;
class TermsAndConditionsState {
}
exports.TermsAndConditionsState = TermsAndConditionsState;
class GetWeatherPredictionsParams extends DTO {
}
exports.GetWeatherPredictionsParams = GetWeatherPredictionsParams;
class GetSchoolHolidaysParams extends DTO {
}
exports.GetSchoolHolidaysParams = GetSchoolHolidaysParams;
/**
 * Transport-agnostic interface defining communication
 * between [[Client]] and [[Server]] instances.
 */
class API {
    updateAccount(_params) {
        throw "not implemented";
    }
    login(_params) {
        throw "not implemented";
    }
    me() {
        throw "not implemented";
    }
    acceptTermsAndConditionsAndProcessingAgreement() {
        throw "not implemented";
    }
    getTermsAndConditionsState() {
        throw "not implemented";
    }
    getCompany(_params) {
        throw "not implemented";
    }
    createCompany(_params) {
        throw "not implemented";
    }
    updateCompany(_params) {
        throw "not implemented";
    }
    deleteCompany(_id) {
        throw "not implemented";
    }
    listCompanies() {
        throw "not implemented";
    }
    selectCompany(_id) {
        throw "not implemented";
    }
    getInvoices(_params) {
        throw "not implemented";
    }
    deleteDraftInvoice(_params) {
        throw "not implemented";
    }
    sendInvoice(_params) {
        throw "not implemented";
    }
    deletePaymentMethod(_params) {
        throw "not implemented";
    }
    revokeSession(_params) {
        throw "not implemented";
    }
    requestSetPassword(_params) {
        throw "not implemented";
    }
    setPassword(_params) {
        throw "not implemented";
    }
    createVenue(_params) {
        throw "not implemented";
    }
    updateVenue(_params) {
        throw "not implemented";
    }
    archiveVenue(_id) {
        throw "not implemented";
    }
    restoreVenue(_params) {
        throw "not implemented";
    }
    createDepartment(_params) {
        throw "not implemented";
    }
    updateDepartment(_params) {
        throw "not implemented";
    }
    archiveDepartment(_id) {
        throw "not implemented";
    }
    createEmployee(_params) {
        throw "not implemented";
    }
    getTagsForEmployee(_params) {
        throw "not implemented";
    }
    getEmployeeTagsForCompany() {
        throw "not implemented";
    }
    getEmployees(_params) {
        throw "not implemented";
    }
    updateEmployee(_params) {
        throw "not implemented";
    }
    updateEmployees(_params) {
        throw "not implemented";
    }
    deleteEmployee(_params) {
        throw "not implemented";
    }
    getTimeEntries(_params) {
        throw "not implemented";
    }
    updateTimeEntries(_params) {
        throw "not implemented";
    }
    restoreDeletedTimeEntries(_params) {
        throw "not implemented";
    }
    publishRoster(_params) {
        throw "not implemented";
    }
    getPublishedRoster(_params) {
        throw "not implemented";
    }
    sendMessage(_params) {
        throw "not implemented";
    }
    getPublicRosterUrl(_params) {
        throw "not implemented";
    }
    getEmployeeIssues(_params) {
        throw "not implemented";
    }
    getRevenueIssues(_params) {
        throw "not implemented";
    }
    getIssues(_params) {
        throw "not implemented";
    }
    ignoreIssues(_params) {
        throw "not implemented";
    }
    getRevenueEntriesCount(_params) {
        throw "not implemented";
    }
    getRevenueEntries(_params) {
        throw "not implemented";
    }
    updateRevenueEntries(_params) {
        throw "not implemented";
    }
    unlockRevenueEntries(_params) {
        throw "not implemented";
    }
    commitCashbook(_params) {
        throw "not implemented";
    }
    getRevenueGroups(_params) {
        throw "not implemented";
    }
    updateRevenueGroup(_params) {
        throw "not implemented";
    }
    deleteRevenueGroup(_id) {
        throw "not implemented";
    }
    getRevenuePredictions(_params) {
        throw "not implemented";
    }
    updateRevenuePredictions(_params) {
        throw "not implemented";
    }
    getRosterTargets(_params) {
        throw "not implemented";
    }
    updateRosterTargets(_params) {
        throw "not implemented";
    }
    startSetupPayment(_params) {
        throw "not implemented";
    }
    sendTimeTrackerLog(_log) {
        throw "not implemented";
    }
    importVenue(_params) {
        throw "not implemented";
    }
    createAbsence(_params) {
        throw "not implemented";
    }
    updateAbsence(_params) {
        throw "not implemented";
    }
    deleteAbsence(_params) {
        throw "not implemented";
    }
    getAbsences(_params) {
        throw "not implemented";
    }
    requestAbsence(_params) {
        throw "not implemented";
    }
    updateAbsenceRequest(_params) {
        throw "not implemented";
    }
    deleteAbsenceRequest(_params) {
        throw "not implemented";
    }
    createInvites(_params) {
        throw "not implemented";
    }
    getInvite(_params) {
        throw "not implemented";
    }
    joinCompany(_params) {
        throw "not implemented";
    }
    createOrUpdateTimeSettings(_params) {
        throw "not implemented";
    }
    deleteTimeSettings(_id) {
        throw "not implemented";
    }
    createOrUpdateRosterNote(_params) {
        throw "not implemented";
    }
    deleteRosterNote(_id) {
        throw "not implemented";
    }
    getRosterNotes(_params) {
        throw "not implemented";
    }
    getAvailabilities(_params) {
        throw "not implemented";
    }
    createAvailability(_params) {
        throw "not implemented";
    }
    updateAvailability(_params) {
        throw "not implemented";
    }
    deleteAvailability(_params) {
        throw "not implemented";
    }
    createOrUpdateDocument(_params) {
        throw "not implemented";
    }
    getDocuments(_params) {
        throw "not implemented";
    }
    deleteDocument(_id) {
        throw "not implemented";
    }
    createOrUpdateJobPosting(_params) {
        throw "not implemented";
    }
    getJobPostings() {
        throw "not implemented";
    }
    getJobPosting(_uuid) {
        throw "not implemented";
    }
    deleteJobPosting(_id) {
        throw "not implemented";
    }
    createJobApplication(_params) {
        throw "not implemented";
    }
    deleteJobApplication(_id) {
        throw "not implemented";
    }
    socialSecurityRegistration(_params) {
        throw "not implemented";
    }
    exportCompany(_params) {
        throw "not implemented";
    }
    importCoreData(_params) {
        throw "not implemented";
    }
    importCompany(_params) {
        throw "not implemented";
    }
    export(_params) {
        throw "not implemented";
    }
    createOrUpdateTimeLogDevice(_params) {
        throw "not implemented";
    }
    getTimeLogDevices() {
        throw "not implemented";
    }
    deleteTimeLogDevice(_id) {
        throw "not implemented";
    }
    getTimeLogEvents(_params) {
        throw "not implemented";
    }
    getDailyResults(_params) {
        throw "not implemented";
    }
    getCommonWorkDays(_params) {
        throw "not implemented";
    }
    /** @deprecated Use `getTimeBalances`, `getVacationBalances`, `getBonusesBalances` instead */
    getBalances(_params) {
        throw "not implemented";
    }
    getTimeBalances(_params) {
        throw "not implemented";
    }
    getVacationBalances(_params) {
        throw "not implemented";
    }
    getBonusesBalances(_params) {
        throw "not implemented";
    }
    resetBalances(_params) {
        throw "not implemented";
    }
    getTimeReports(_params) {
        throw "not implemented";
    }
    getCostReports(_params) {
        throw "not implemented";
    }
    getSavingsReports(_params) {
        throw "not implemented";
    }
    getNotificationSettings() {
        throw "not implemented";
    }
    updateNotificationSettings(_settings) {
        throw "not implemented";
    }
    getWeatherPredictions(_params) {
        throw "not implemented";
    }
    getSchoolHolidays(_params) {
        throw "not implemented";
    }
    getLiveKitAuthToken() {
        throw "not implemented";
    }
    getNote(_type) {
        throw "not implemented";
    }
    saveNote(_params) {
        throw "not implemented";
    }
}
exports.API = API;
__decorate([
    Handler(UpdateAccountParams, model_1.Account),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAccountParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAccount", null);
__decorate([
    Handler(LoginParams, index_1.SessionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LoginParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "login", null);
__decorate([
    Handler(undefined, index_1.AccountDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "me", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "acceptTermsAndConditionsAndProcessingAgreement", null);
__decorate([
    Handler(undefined, TermsAndConditionsState),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getTermsAndConditionsState", null);
__decorate([
    Handler(GetCompanyParams, model_1.Company),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCompany", null);
__decorate([
    Handler(CreateCompanyParams, model_1.Company),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createCompany", null);
__decorate([
    Handler(UpdateCompanyParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateCompany", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteCompany", null);
__decorate([
    Handler(undefined, model_1.Company),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "listCompanies", null);
__decorate([
    Handler(Number, index_1.SessionDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "selectCompany", null);
__decorate([
    Handler(GetInvoicesParams, invoice_1.Invoice),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetInvoicesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getInvoices", null);
__decorate([
    Handler(DeleteDraftInvoiceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteDraftInvoiceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteDraftInvoice", null);
__decorate([
    Handler(SendInvoiceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SendInvoiceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendInvoice", null);
__decorate([
    Handler(DeletePaymentMethodParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeletePaymentMethodParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deletePaymentMethod", null);
__decorate([
    Handler(RevokeSessionParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RevokeSessionParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "revokeSession", null);
__decorate([
    Handler(RequestSetPasswordParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RequestSetPasswordParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "requestSetPassword", null);
__decorate([
    Handler(SetPasswordParams, model_1.Account),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SetPasswordParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "setPassword", null);
__decorate([
    Handler(CreateVenueParams, model_1.Venue),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createVenue", null);
__decorate([
    Handler(UpdateVenueParams, model_1.Venue),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateVenue", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "archiveVenue", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "restoreVenue", null);
__decorate([
    Handler(CreateDepartmentParams, model_1.Department),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateDepartmentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createDepartment", null);
__decorate([
    Handler(UpdateDepartmentParams, model_1.Department),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateDepartmentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateDepartment", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "archiveDepartment", null);
__decorate([
    Handler(CreateEmployeeParams, model_1.Employee),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createEmployee", null);
__decorate([
    Handler(employee_tag_dto_1.GetTagsForEmployeeParams, index_1.EmployeeTagDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [employee_tag_dto_1.GetTagsForEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTagsForEmployee", null);
__decorate([
    Handler(undefined, index_1.EmployeeTagDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeeTagsForCompany", null);
__decorate([
    Handler(GetEmployeesParams, index_1.EmployeeDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployees", null);
__decorate([
    Handler(UpdateEmployeeParams, model_1.Employee),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateEmployee", null);
__decorate([
    Handler(UpdateEmployeesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateEmployeesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateEmployees", null);
__decorate([
    Handler(DeleteEmployeeParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteEmployeeParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteEmployee", null);
__decorate([
    Handler(GetTimeEntriesParams, model_1.TimeEntry, {
        transforms: [
            {
                clientVersionBefore: "1.25.0",
                transformOutput: ({ startPlanned, endPlanned, startLogged, endLogged, startFinal, endFinal, published, seen, mealsBreakfast, mealsDinner, mealsLunch, ...rest }) => ({
                    ...rest,
                    startPlanned: (0, utils_1.toTimeString)(startPlanned),
                    endPlanned: (0, utils_1.toTimeString)(endPlanned),
                    startLogged: (0, utils_1.toTimeString)(startLogged),
                    endLogged: (0, utils_1.toTimeString)(endLogged),
                    startFinal: (0, utils_1.toTimeString)(startFinal),
                    endFinal: (0, utils_1.toTimeString)(endFinal),
                    published: published && {
                        ...published,
                        startPlanned: published.startPlanned && (0, utils_1.toTimeString)(published.startPlanned),
                        endPlanned: published.endPlanned && (0, utils_1.toTimeString)(published.endPlanned),
                    },
                    seen: seen && {
                        ...seen,
                        startPlanned: seen.startPlanned && (0, utils_1.toTimeString)(seen.startPlanned),
                        endPlanned: seen.endPlanned && (0, utils_1.toTimeString)(seen.endPlanned),
                    },
                    meals: mealsBreakfast || 0 + mealsDinner || 0 + mealsLunch || 0,
                }),
            },
        ],
    }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeEntries", null);
__decorate([
    Handler(UpdateTimeEntriesParams, undefined, {
        transforms: [
            {
                clientVersionBefore: "1.25.0",
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                transformInput: ({ updated, removed, ...rest }) => {
                    const transform = ({ date, startPlanned, endPlanned, startLogged, endLogged, startFinal, endFinal, published, seen, meals, ...rest
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                     }) => {
                        [startPlanned, endPlanned] = (0, utils_1.parseTimes)(date, startPlanned, endPlanned);
                        [startLogged, endLogged] = (0, utils_1.parseTimes)(date, startLogged, endLogged);
                        [startFinal, endFinal] = (0, utils_1.parseTimes)(date, startFinal, endFinal);
                        const publishedTimes = published && (0, utils_1.parseTimes)(published.date, published.startPlanned, published.endPlanned);
                        const seenTimes = seen && (0, utils_1.parseTimes)(seen.date, seen.startPlanned, seen.endPlanned);
                        return {
                            ...rest,
                            date,
                            startPlanned,
                            endPlanned,
                            startLogged,
                            endLogged,
                            startFinal,
                            endFinal,
                            published: published && {
                                ...published,
                                startPlanned: publishedTimes[0],
                                endPlanned: publishedTimes[1],
                            },
                            seen: seen && {
                                ...seen,
                                startPlanned: seenTimes[0],
                                endPlanned: seenTimes[1],
                            },
                            mealsLunch: meals,
                            mealsBreakfast: 0,
                            mealsDinner: 0,
                        };
                    };
                    return {
                        updated: (updated || []).map(transform),
                        removed: (removed || []).map(transform),
                        ...rest,
                    };
                },
            },
        ],
    }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateTimeEntries", null);
__decorate([
    Handler(RestoreDeletedTimeEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RestoreDeletedTimeEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "restoreDeletedTimeEntries", null);
__decorate([
    Handler(PublishRosterParams, Boolean),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishRosterParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "publishRoster", null);
__decorate([
    Handler(GetPublishedRosterParams, index_1.PublishedRosterDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetPublishedRosterParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getPublishedRoster", null);
__decorate([
    Handler(SendMessageParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SendMessageParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendMessage", null);
__decorate([
    Handler(GetPublicRosterUrlParams, GetPublicRosterUrlResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetPublicRosterUrlParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getPublicRosterUrl", null);
__decorate([
    Handler(GetEmployeeIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetEmployeeIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getEmployeeIssues", null);
__decorate([
    Handler(GetRevenueIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueIssues", null);
__decorate([
    Handler(GetIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getIssues", null);
__decorate([
    Handler(IgnoreIssuesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [IgnoreIssuesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "ignoreIssues", null);
__decorate([
    Handler(GetRevenueEntriesCountParams, (Promise)),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueEntriesCountParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueEntriesCount", null);
__decorate([
    Handler(GetRevenueEntriesParams, model_1.RevenueEntry),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueEntries", null);
__decorate([
    Handler(UpdateRevenueEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenueEntries", null);
__decorate([
    Handler(UnlockRevenueEntriesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UnlockRevenueEntriesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "unlockRevenueEntries", null);
__decorate([
    Handler(CommitCashbookParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CommitCashbookParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "commitCashbook", null);
__decorate([
    Handler(GetRevenueGroupsParams, model_1.RevenueGroup),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenueGroupsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenueGroups", null);
__decorate([
    Handler(UpdateRevenueGroupParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenueGroupParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenueGroup", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteRevenueGroup", null);
__decorate([
    Handler(GetRevenuePredictionsParams, model_1.RevenuePrediction),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRevenuePredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRevenuePredictions", null);
__decorate([
    Handler(UpdateRevenuePredictionsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRevenuePredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRevenuePredictions", null);
__decorate([
    Handler(GetRosterTargetsParams, model_1.RosterTargets),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterTargetsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterTargets", null);
__decorate([
    Handler(UpdateRosterTargetsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateRosterTargetsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateRosterTargets", null);
__decorate([
    Handler(StartSetupPaymentParams, StartSetupPaymentResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StartSetupPaymentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "startSetupPayment", null);
__decorate([
    Handler(TimeTrackerLog, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [TimeTrackerLog]),
    __metadata("design:returntype", Promise)
], API.prototype, "sendTimeTrackerLog", null);
__decorate([
    Handler(ImportVenueParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ImportVenueParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "importVenue", null);
__decorate([
    Handler(model_1.Absence, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.Absence]),
    __metadata("design:returntype", Promise)
], API.prototype, "createAbsence", null);
__decorate([
    Handler(model_1.Absence, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.Absence]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAbsence", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAbsence", null);
__decorate([
    Handler(GetAbsencesParams, model_1.Absence),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetAbsencesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getAbsences", null);
__decorate([
    Handler(RequestAbsenceParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RequestAbsenceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "requestAbsence", null);
__decorate([
    Handler(UpdateAbsenceRequestParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UpdateAbsenceRequestParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAbsenceRequest", null);
__decorate([
    Handler(DeleteAbsenceRequestParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DeleteAbsenceRequestParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAbsenceRequest", null);
__decorate([
    Handler(CreateInvitesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateInvitesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createInvites", null);
__decorate([
    Handler(String, GetInviteResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getInvite", null);
__decorate([
    Handler(JoinCompanyParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [JoinCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "joinCompany", null);
__decorate([
    Handler(model_1.TimeSettings, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.TimeSettings]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateTimeSettings", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteTimeSettings", null);
__decorate([
    Handler(index_1.RosterNoteDTO, index_1.RosterNoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [index_1.RosterNoteDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateRosterNote", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteRosterNote", null);
__decorate([
    Handler(GetRosterNotesParams, index_1.RosterNoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetRosterNotesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getRosterNotes", null);
__decorate([
    Handler(GetAvailabilitesParams, model_1.Availability),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetAvailabilitesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getAvailabilities", null);
__decorate([
    Handler(model_1.Availability, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.Availability]),
    __metadata("design:returntype", Promise)
], API.prototype, "createAvailability", null);
__decorate([
    Handler(model_1.Availability, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [model_1.Availability]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateAvailability", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteAvailability", null);
__decorate([
    Handler(CreateOrUpdateDocumentParams, model_1.Document),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateDocumentParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateDocument", null);
__decorate([
    Handler(GetDocumentsParams, model_1.Document),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetDocumentsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getDocuments", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteDocument", null);
__decorate([
    Handler(CreateOrUpdateJobPostingParams, model_1.JobPosting),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateJobPostingParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateJobPosting", null);
__decorate([
    Handler(undefined, model_1.JobPosting),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getJobPostings", null);
__decorate([
    Handler(String, model_1.JobPosting),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getJobPosting", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteJobPosting", null);
__decorate([
    Handler(CreateJobApplicationParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateJobApplicationParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createJobApplication", null);
__decorate([
    Handler(Number, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteJobApplication", null);
__decorate([
    Handler(SocialSecurityRegistrationParams, SocialSecurityRegistrationResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [SocialSecurityRegistrationParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "socialSecurityRegistration", null);
__decorate([
    Handler(ExportCompanyParams, CompanyExport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ExportCompanyParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "exportCompany", null);
__decorate([
    Handler(ImportCoreDataParams, ImportCoreDataResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ImportCoreDataParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "importCoreData", null);
__decorate([
    Handler(CompanyExport, ImportCompanyResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CompanyExport]),
    __metadata("design:returntype", Promise)
], API.prototype, "importCompany", null);
__decorate([
    Handler(ExportParams, ExportResponse),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ExportParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "export", null);
__decorate([
    Handler(CreateOrUpdateTimeLogDeviceParams, model_1.TimeLogDevice),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [CreateOrUpdateTimeLogDeviceParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "createOrUpdateTimeLogDevice", null);
__decorate([
    Handler(undefined, model_1.TimeLogDevice),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeLogDevices", null);
__decorate([
    Handler(String, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "deleteTimeLogDevice", null);
__decorate([
    Handler(GetTimeLogEventsParams, model_1.TimeLogEvent),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeLogEventsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeLogEvents", null);
__decorate([
    Handler(GetDailyResultsParams, index_1.DailyResultsDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetDailyResultsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getDailyResults", null);
__decorate([
    Handler(GetCommonWorkDaysParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCommonWorkDaysParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCommonWorkDays", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getVacationBalances", null);
__decorate([
    Handler(GetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getBonusesBalances", null);
__decorate([
    Handler(ResetBalancesParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ResetBalancesParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "resetBalances", null);
__decorate([
    Handler(GetTimeReportsParams, TimeReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTimeReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getTimeReports", null);
__decorate([
    Handler(GetTimeReportsParams, TimeReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetCostReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getCostReports", null);
__decorate([
    Handler(GetSavingsReportsParams, SavingsReport),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetSavingsReportsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getSavingsReports", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getNotificationSettings", null);
__decorate([
    Handler(undefined, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], API.prototype, "updateNotificationSettings", null);
__decorate([
    Handler(GetWeatherPredictionsParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetWeatherPredictionsParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getWeatherPredictions", null);
__decorate([
    Handler(GetSchoolHolidaysParams, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetSchoolHolidaysParams]),
    __metadata("design:returntype", Promise)
], API.prototype, "getSchoolHolidays", null);
__decorate([
    Handler(undefined, index_1.LiveKitAuthTokenDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], API.prototype, "getLiveKitAuthToken", null);
__decorate([
    Handler(String, index_1.NoteDTO),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], API.prototype, "getNote", null);
__decorate([
    Handler(index_1.NoteDTO, undefined),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [index_1.NoteDTO]),
    __metadata("design:returntype", Promise)
], API.prototype, "saveNote", null);
//# sourceMappingURL=api.js.map